import { render, staticRenderFns } from "./AssignAgentModal.vue?vue&type=template&id=2a78d42b&"
import script from "./AssignAgentModal.vue?vue&type=script&lang=js&"
export * from "./AssignAgentModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports